/**
 * Analytics service for tracking page views and events via GTM dataLayer.
 */

import { pushEvent } from '@/lib/utils/dataLayer';

/**
 * Track a page view.
 */
export function trackPageView(path: string): void {
  pushEvent('page_view', { page_path: path });
}

/**
 * Track a user event.
 */
export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>
): void {
  pushEvent(eventName, properties);
}
